module.exports = __webpack_public_path__ + "static/img/miaoji.2cdeb98a.svg";